import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ColDef, GridOptions } from 'ag-grid-community';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { DocumentsRepositoryService } from 'src/app/services/documents-repository.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { DocumentsDetails, DocumentsDetailsRawData, FolderStructure, FolderSubFoldersTransform, GetDocumentTypesRequest, SaveGridState, SupplierDetails } from 'src/app/shared/models/documents.model';
import { User } from 'src/app/shared/models/user.model';
import { ToolTipComponent } from '../tool-tip/tool-tip.component';

@Component({
  selector: "app-folders-view",
  templateUrl: "./folders-view.component.html",
  styleUrls: ["./folders-view.component.scss"],
})

export class FoldersViewComponent implements OnInit {
  @Output() uploadForm: EventEmitter<SupplierDetails> = new EventEmitter<SupplierDetails>();
  @Output() editFormHandler: EventEmitter<string> = new EventEmitter<string>();
  @Input() supplierDetails: SupplierDetails;
  @Input() isSupplierChanged: boolean;
  private unsubscribe: Subject<void> = new Subject<void>();
  private saveGridOption: GridOptions[] = [];
  rowData:
    | FolderSubFoldersTransform[]
    | FolderSubFoldersTransform[]
    | DocumentsDetails[]
    | any;
    documentsDetails!: DocumentsDetails[];
  frameworkComponents: [];
  saveRowData = [];
  columnDefs: ColDef[];
  userActionLastState = [];
  gridOptions: GridOptions;
  editFileDetails: DocumentsDetailsRawData;
  onHoverTooltip: any;
  isLoadingData: boolean;
  editUploadedfile: Boolean;
  hasPermission: boolean = false;
  folderStructure: FolderStructure;
  breadCrumb: string[];
  MAINFOLDERS: string = "Main Folders";
  filePathLocation: string;
  subFolderName: string;
  subFolderId: string;
  mainFolderId: string;
  tooltipOptions: Object;
  loggedUserDetails: User;
  paginationPageSize: number;
  folderSubfolderColDefs: ColDef[] = [
    {
      headerName: AppConstants.Name,
      field: AppConstants.nameField,
      sortable: true,
      sort: "",
      sortingOrder: ["asc", "desc"],
      width: 480,
      filter: true,
      cellStyle: { "white-space": "normal" },
      cellRenderer: "tooltipMessage",
    },
    /* {
       headerName: AppConstants.UploadBy,
       field: AppConstants.uploadbyField,
       unSortIcon: true,
       sortingOrder: ["asc", "desc"],
       sortable: true,
       cellClass: "abc",
       filter: true,
       width: 200,
     },
     {
       headerName: AppConstants.UploadOn,
       field: AppConstants.uploadonField,
       unSortIcon: true,
       sortingOrder: ["asc", "desc"],
       sortable: true,
       filter: true,
       width: 200,
     }, */
  ];

  documentsColDefs: ColDef[] = [
    {
      headerName: AppConstants.Name,
      field: 'name',
      sortable: true,
      //sort: "asc",
      unSortIcon: true,
      sortingOrder: ["asc", "desc"],
      width: 338,
      filter: true,
      cellRenderer: "tooltipMessage",
      cellStyle: { "white-space": "normal" },
      autoHeight: true,
      resizable: true
    },
    {
      headerName: AppConstants.UploadBy,
      field: 'uploadedBy',
      sortingOrder: ["asc", "desc"],
      sortable: true,
      unSortIcon: true,
      filter: true,
      cellStyle: { "white-space": "normal" },
      autoHeight: true,
      width: 147,
      resizable: true
    },
    {
      headerName: AppConstants.UploadOn,
      field: 'uploadedOn',
      sortingOrder: ["desc", "asc"],
      sort: "desc",
      sortIndex: 0,
      comparator: this.dateComparator,
      sortable: true,
      unSortIcon: true,
      filter: true,
      cellStyle: { "white-space": "normal" },
      autoHeight: true,
      width: 145,
      resizable: true
    },
    {
      headerName: AppConstants.SolarPartNumber,
      field: 'solarPartNumber',
      sortingOrder: ["asc", "desc"],
      sortable: true,
      unSortIcon: true,
      filter: true,
      width: 184,
      cellClass:'sg-search',
     //cellStyle: { "white-space": "normal" },
      autoHeight: true,
      resizable: true
    },
    {
      headerName: AppConstants.PurchaseOrder,
      field: 'purchaseOrder',
      sortingOrder: ["asc", "desc"],
      sortable: true,
      unSortIcon: true,
      filter: true,
      width: 163,
      cellStyle: { "white-space": "normal" },
      autoHeight: true,
      resizable: true
    },
    {
      headerName: AppConstants.SerialNumber,
      field: 'serialNumber',
      sortingOrder: ["asc", "desc"],
      sortable: true,
      unSortIcon: true,
      filter: true,
      width: 158,
      cellStyle: { "white-space": "normal" },
      autoHeight: true,
      resizable: true
    },
    {
      headerName: AppConstants.LastEdited,
      field: 'lastModifiedBy',
      sortingOrder: ["asc", "desc"],
      sortable: true,
      unSortIcon: true,
      filter: true,
      width: 150,
      cellStyle: { "white-space": "normal" },
      autoHeight: true,
      resizable: true
    },
  ];

  renderFilesExecuted: boolean = false;

  constructor(
    private documentsService: DocumentsRepositoryService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private userRepositoryService: UserRepositoryService,
    private shareDataService: ShareDataService
  ) {
    this.onHoverTooltip = {
      tooltipMessage: ToolTipComponent,
    };
    this.gridOptions = {
      context: {
        FoldersViewComponent: this,
      },
    };
    this.tooltipOptions = {
      placement: "top",
      "show-delay": "1",
      "hide-delay": "1",
      "tooltip-class": "sg-tooltip-upload",
      tooltipClass: "sg-tooltip-upload",
      pointerEvents: "none",
    };
  }

  ngOnInit(): void {
    this.getBreadCrumbData();
    //this.getFolderStructureData();
  };

  onGridReady(params: GridOptions): void {
    this.isLoadingData = true;
    this.gridOptions = params;
    this.gridOptions.api.sizeColumnsToFit();
    this.shareDataService.getFolderStructure$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {
          this.folderStructure = response;
          if (this.folderStructure) {
            this.setInitialGridData();
            this.registerNotificationView();
          }
        },
        (error) => {
          this.snackBarService.showError(error.message);
        }
      );
  }

  dateComparator(date1: string, date2: string): number {
    return new Date(date1) < new Date(date2) ? -1 : 1;
  }

  // filter data based on user clicked on row
  getFilterData(row) {
    if (row.data.docType) { return; } //prevent user click
    if ((this.breadCrumb.length === 1 && this.documentsService.folderPermission(row.data.name, this.loggedUserDetails)) 
      || this.breadCrumb.length > 1
    ) {
      if (!this.breadCrumb.includes(row.data.name))
        this.breadCrumb.push(row.data.name);
      this.documentsService.breadCrumb.next(this.breadCrumb);
      let skipedBadData = row.data.subFolders.filter((item) => item.subFolderName != "");
      let hasNestedSubFolders = skipedBadData.some((item) => item.subFolders && item.subFolders.length > 0);
      if (skipedBadData.length > 0 || hasNestedSubFolders) {
        this.renderSubfolders(row.data.name, true);
      } else {
        this.renderFilesData();
      }
    } else {
      this.snackBarService.showError(
        AppConstants.insufficientPermissionsMsgError
      );
    }
  }

  //get current Folder path
  getPathFolder(): string {
    let result: string = "";
    this.breadCrumb.length == 2 ? (result = `${this.breadCrumb[1]}`) : this.breadCrumb.length == 4 ? (result = `${this.breadCrumb[1]}\\${this.breadCrumb[2]}\\${this.breadCrumb[3]}`) : (result = `${this.breadCrumb[1]}\\${this.breadCrumb[2]}`);
    return result;
  }

  //get all uploaded files
  getFilesData(filePathData: GetDocumentTypesRequest): void {
    this.documentsService
      .getUploadedFilesByPath(filePathData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response) => {
          if (response.length > 0) {
            this.documentsDetails = this.docGridData(response, this.breadCrumb[1]);         
            this.documentsDetails.sort((a: any, b: any) => {
              return <any>new Date(b.uploadedOn) - <any>new Date(a.uploadedOn);
                      });
              this.renderFileDetails();      
          } else {
            this.documentsDetails = [
              {
                id: "",
                name: "File & Folder is not available.",
                uploadedBy: "",
                uploadedOn: "",
                solarPartNumber: "",
                purchaseOrder: "",
                serialNumber: "",
                docType: true,
              },
            ];
            this.renderFileDetails();
            return;
          }
      });
  }

  //convert folders backend response to display in ag grid table.
  private foldersGridData(
    folderData: FolderStructure
  ): FolderSubFoldersTransform[] {
    return folderData.folderStructure.map((item) => ({
      name: item.folderName,
      uploadOn: "",
      uploadBy: "",
      subFolders: item.subFolders,
      id: item.folderId.toString(),
      docType: false,
      hasPermission: this.documentsService.folderPermission(
        item.folderName,
        this.loggedUserDetails,
        true
      ),
    }));
  }

  //convert SubFolders backend response to display in ag grid table.
  private subFoldersGridData(
    subFolderResponse,
    folderName: string
  ): FolderSubFoldersTransform[] {
    return subFolderResponse.map((item) => ({
      name: item.subFolderName,
      uploadOn: "",
      uploadBy: "",
      subFolders: item.documentType == null ? item.subFolders : [], ///
      documentType: item.documentType,
      id: item.subFolderId,
      docType: false,
      hasPermission: this.documentsService.folderPermission(
        folderName,
        this.loggedUserDetails,
        true
      ),
    }));
  }

  //convert files backend response to display in ag grid table.
  private docGridData(docomentDetails: DocumentsDetailsRawData[], folderName: string): DocumentsDetails[] {
    this.paginationPageSize = 10;
    return docomentDetails.map((docomentDetails) => ({
      id: docomentDetails.fileId,
      name: docomentDetails.documentName,
      uploadedBy: docomentDetails.createdBy,
      uploadedOn: moment(docomentDetails.createdUtc).format("DD MMM YYYY"),
      solarPartNumber: docomentDetails.uiDocumentAttributesDTO.documentAttributes.additionalInformation.solarPartNumber,
      purchaseOrder: docomentDetails.uiDocumentAttributesDTO.documentAttributes.additionalInformation.purchaseOrder,
      serialNumber: docomentDetails.uiDocumentAttributesDTO.documentAttributes.additionalInformation.serialNumber,
      lastModifiedBy: docomentDetails.lastModifiedBy,
      docType: true,
      hasPermission: this.documentsService.folderPermission(folderName, this.loggedUserDetails, true),
    }));
  }

  uploadLocation(locationPath?: string, isDeleteRecordConfirm?: boolean): void {    
    this.restoreState(0);
    let fileUploadedLocationPath = locationPath.split("\\");
    fileUploadedLocationPath[0] = this.MAINFOLDERS;
    this.breadCrumb = fileUploadedLocationPath;
    this.renderSubfolders(fileUploadedLocationPath.length === 4 ? fileUploadedLocationPath[2] : fileUploadedLocationPath[1], false, isDeleteRecordConfirm);
    
  };

  //click events handler code start here
  openDrawerHandler() {
    this.uploadForm.emit(this.supplierDetails);
  }

  editOpenDrawerHandler(id: string): void {
    this.editFormHandler.emit(id);
  }

  private getLogedUser() {
    this.userRepositoryService.loggedUserData$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((user: User) => {
        this.loggedUserDetails = user;
      });
  }
//
  restoreState(idx: number): void {
    this.paginationPageSize = 20;
    if (this.folderStructure) {
      this.columnDefs = this.folderSubfolderColDefs;
      //this.gridOptions.columnApi.setColumnState(
      this.gridOptions.columnApi.applyColumnState(
        //this.columnDefs
        {
          state:this.columnDefs,
          applyOrder: true,
        }
      );
      this.gridOptions.api.setRowData(this.saveRowData[idx]);
      //this.gridOptions.api.setSortModel(
        this.gridOptions.columnApi.applyColumnState(
        //this.saveGridOption[idx].columnApi.getColumnState()
        {
          state:this.saveGridOption[idx].columnApi.getColumnState(),
          applyOrder: true,
        }

      );
      if (idx === 0) {
        this.saveGridOption.splice(idx + 1, this.saveGridOption.length - 1);
        this.saveRowData.splice(idx + 1, this.saveRowData.length - 1)
        this.breadCrumb.splice(idx + 1, this.breadCrumb.length - 1)
        this.documentsService.saveGridOption = this.saveGridOption;
        this.documentsService.saveRowData = this.saveRowData;
      } else {
        this.breadCrumb.length - 1;
        this.saveGridOption.splice(idx + 1, ((this.saveGridOption.length-1)-idx+1));
        this.saveRowData.splice(idx + 1, ((this.saveRowData.length-1)-idx+1));
        this.breadCrumb.splice(idx + 1, this.breadCrumb.length - 1);
        
        this.documentsService.saveGridOption = this.saveGridOption;
        this.documentsService.saveRowData = this.saveRowData;
      
      }
    }
  }
//
  private saveState(gridOptions: GridOptions, rowData, onLoad?:boolean): void {  
    if (onLoad) {
      this.saveRowData = [];
      this.saveGridOption = [];
      this.saveRowData.push(rowData);
      this.saveGridOption.push(gridOptions);
    } else {
      this.saveRowData.push(rowData);
      this.saveGridOption.push(gridOptions);
     
    }
    
  }

  restoreUserState() {
    if (this.documentsService.saveGridOption.length > 1) {
      let gridLevel = false;
      
      this.saveGridOption = this.documentsService.saveGridOption;
      this.saveRowData = this.documentsService.saveRowData;
   
      this.restoreState(this.saveGridOption.length - 1);
      
     
      this.documentsService.saveGridOption.forEach(a => {
        if(a.rowData.find(d => d.docType == true)) {
          gridLevel = true;
        }
       });
    
      // console.log(this.saveGridOption);
      // console.log(this.saveRowData);
     
      if (this.documentsService.saveGridOption.length >= 3 && gridLevel) { // remove .length >= 3  to bcz it pushing two times
        this.renderFilesData();
      }
    }
  }

  private renderFilesData(): void {
    let filePathData: GetDocumentTypesRequest = new GetDocumentTypesRequest();
    filePathData.folderPath = this.getPathFolder();
    filePathData.supplierId = this.supplierDetails.id; 
    this.getFilesData(filePathData);
  };

  private renderSubfolders(name: string, rowCLick: boolean, isDeleteRecordConfirm?: boolean): void {
    this.gridOptions.api.forEachNode((node) => {
      const transeformData = this.subFoldersGridData(node.data.subFolders, node.data.name);
      if ((this.breadCrumb.length === 2 && !rowCLick) || node.data.name === name) { 
        if (transeformData[0].name) {
          this.columnDefs = this.folderSubfolderColDefs;
          this.rowData = transeformData.sort((a,b) => (a.name < b.name ? -1 : 1));
          this.gridOptions.api.setColumnDefs(this.columnDefs);
          this.saveState(this.gridOptions, this.rowData);
        }
        return;
      } 
      
      if (this.breadCrumb.length === 3 && !rowCLick ) { 
        const filterDocType = this.saveRowData[this.saveRowData.length - 1].filter(x => x.name === 
          this.breadCrumb[this.breadCrumb.length - 1]);
        if (filterDocType && filterDocType.length > 0) {
          if (!this.renderFilesExecuted) {
            this.renderFilesData();
            this.renderFilesExecuted = true;
            this.documentsService.breadCrumb.next(this.breadCrumb);
          }
          return;
        }
      }

      if (this.breadCrumb.length === 4 && !rowCLick) {
        const filterDocType = this.saveRowData[this.saveRowData.length - 1].filter(x => x.name === 
          this.breadCrumb[this.breadCrumb.length - 1]);
        const documentTypeNullItems = transeformData.filter((item) => item.documentType === null);
        
        for(const item of documentTypeNullItems) {
          if(item.subFolders ) {  //=== name (this.breadCrumb[this.breadCrumb.length-1])
            // item.subFolders.some((subFolder) => subFolder.subFolderName === name)
           
              this.columnDefs = this.folderSubfolderColDefs;
              this.rowData = transeformData.sort((a,b) => (a.name < b.name ? -1 : 1));
              this.gridOptions.api.setColumnDefs(this.columnDefs);
              this.saveState(this.gridOptions, this.rowData);
              if(item.name == name) {
              const transeformSubFolderData = this.subFoldersGridData(item.subFolders, item.name);
              this.columnDefs = this.folderSubfolderColDefs;
              this.rowData = transeformSubFolderData.sort((a,b) => (a.name < b.name ? -1 : 1));
              this.gridOptions.api.setColumnDefs(this.columnDefs);
              this.saveState(this.gridOptions, this.rowData);
              
              if (!this.renderFilesExecuted) {
                this.renderFilesData();
               
                this.documentsService.breadCrumb.next(this.breadCrumb);
              }
              }
              return;
          
          }
        }
      } 
     
     
    });
  };
  

  private renderFileDetails(): void {
    this.columnDefs = this.documentsColDefs;
    this.gridOptions.api.setColumnDefs(this.columnDefs);
    this.rowData = this.documentsDetails;
    this.saveState(this.gridOptions, this.rowData);
  };

  private getBreadCrumbData(): void {
    this.getLogedUser();
    this.breadCrumb = [this.MAINFOLDERS];
    this.documentsService.breadCrumb$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: string[]) => {
        if (data.length > 1) {
          this.breadCrumb = data;
        }
      });
  };

  private setInitialGridData(): void {
    let folders = this.foldersGridData(this.folderStructure);
    this.columnDefs = this.folderSubfolderColDefs;
    this.rowData = folders.sort((a,b) => (a.name < b.name ? -1 : 1));
    this.gridOptions.api.setColumnDefs(this.columnDefs);
    this.saveState(this.gridOptions, folders, true);
    this.isLoadingData = false;
  }
  private registerNotificationView(){
    this.userRepositoryService.notoficationDocSelected
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((item) => {
        if(item){
         let path= this.getNotificationFolderName(item.documentType);
         this.uploadLocation(path, false);
        }
      })
  }
  private getNotificationFolderName(docName):string {
       let docFound = false;
       let filePath = "";
       for (let i = 0; i < this.folderStructure.folderStructure.length; i++) {
         if (docFound) {
           break;
         }
         for (
           let j = 0;
           j < this.folderStructure.folderStructure[i].subFolders.length;
           j++
         ) {
           const docType = this.folderStructure.folderStructure[i].subFolders[
             j
           ].documentType.filter(
             (docType) => docType.documentTypeName === docName.documentType
           );
           if (docType.length > 0) {
             filePath = 
             `MainFolder\\${this.folderStructure.folderStructure[i].folderName}\\
             ${this.folderStructure.folderStructure[i].subFolders[j].subFolderName}`;
             docFound = true;
             return filePath;
           }
         }
       }
  }

  ngOnDestroy() {
    this.documentsService.saveGridOption = this.saveGridOption;
    this.documentsService.saveRowData = this.saveRowData;
  };
}
